module.exports = __webpack_public_path__ + "img/open-icon.dad6e591.svg";